import {API, Project} from "@brg/api";
import {FC, useMemo} from "react";
import { useTranslation } from "react-i18next";
import {AdaptiveCardWrapper} from "@brg/ui";
import {AppTester, getCurrentAppName, getCurrentContextName} from "../../../supporting";
import {getCardNumber} from "../../helpers/utils/getCardNumber";
import styled from "styled-components";
import useQueryState from "shared/hooks/useQueryState";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

export const WarholCardCoverBg = styled.div`
    background: white;
    width: 100%;
    height: 100%;
`

export const WarholCardCoverEditBg = styled(WarholCardCoverBg)`
    box-shadow: 0px 4px 4px rgba(61, 59, 89, 0.06);
`

export const WarholCardCover: FC<{ project?: Project<'Global'> | Project<'Local'> }> = ({ project }) => {
    const { i18n: { language } } = useTranslation();
    const isMediiiaAstro = AppTester.isMediiiaNature();
    const [{ tab }] = useQueryState();
    //@ts-ignore
    const templateType = useMemo(() => (project?.additionalInfo?.['templateType'] && JSON.parse(project?.additionalInfo?.['templateType'])), [project]);
    //@ts-ignore
    const templateData = useMemo(() => (project?.additionalInfo?.['templateData'] && API.toLang(JSON.parse(project?.additionalInfo?.['templateData']), language)), [project, language]);
    const appName = getCurrentAppName();
    const contextName = getCurrentContextName();

    const images = useMemo(() => {
        if (!project?.titleImages) return [];
        return project?.titleImages
    } , [project]);

    const templateTypeName = useMemo(() => {
        if (isMediiiaAstro && tab === 'floral') {
            return 'FlowerHoroscopeCardA4'
        }

        return (templateType?.nameComponent
        ? templateType?.nameComponent?.endsWith('L')
            ? templateType?.nameComponent?.slice(0,-1)
            : templateType?.nameComponent
        : 'WarholCardA4')
    }, [templateType?.nameComponent, isMediiiaAstro, tab])

    const cardNumber = useMemo(() => getCardNumber(templateData?.number), [templateData?.number])

    const cardProps = useMemo(() => ({
        data: {
            templateType: {...templateType, link: window.location.hostname},
            templateData: {...templateData, link: window.location.hostname},
            number: cardNumber
        },
        templateType: templateTypeName,
        appName,
        contextName
    }), [templateType, templateData, cardNumber, templateTypeName, appName, contextName])

    if (!templateType || !templateData) {
        return null;
    }

    return (
            <AdaptiveCardWrapper cardProps={cardProps} images={images}>
                <CardComponent.MasterCard />
            </AdaptiveCardWrapper>
    );
}import {API, Project} from "@brg/api";
import {FC, useMemo} from "react";
import { useTranslation } from "react-i18next";
import {AdaptiveCardWrapper} from "@brg/ui";
import {AppTester, getCurrentAppName, getCurrentContextName} from "../../../supporting";
import {getCardNumber} from "../../helpers/utils/getCardNumber";
import styled from "styled-components";
import useQueryState from "shared/hooks/useQueryState";
import { isServer } from 'shared/constants/isServer';
const CardComponent = isServer ? {} : require('adaptive-cards');

export const WarholCardCoverBg = styled.div`
    background: white;
    width: 100%;
    height: 100%;
`

export const WarholCardCoverEditBg = styled(WarholCardCoverBg)`
    box-shadow: 0px 4px 4px rgba(61, 59, 89, 0.06);
`

export const WarholCardCover: FC<{ project?: Project<'Global'> | Project<'Local'> }> = ({ project }) => {
    const { i18n: { language } } = useTranslation();
    const isMediiiaAstro = AppTester.isMediiiaNature();
    const [{ tab }] = useQueryState();
    //@ts-ignore
    const templateType = useMemo(() => (project?.additionalInfo?.['templateType'] && JSON.parse(project?.additionalInfo?.['templateType'])), [project]);
    //@ts-ignore
    const templateData = useMemo(() => (project?.additionalInfo?.['templateData'] && API.toLang(JSON.parse(project?.additionalInfo?.['templateData']), language)), [project, language]);
    const appName = getCurrentAppName();
    const contextName = getCurrentContextName();

    const images = useMemo(() => {
        if (!project?.titleImages) return [];
        return project?.titleImages
    } , [project]);

    const templateTypeName = useMemo(() => {
        if (isMediiiaAstro && tab === 'floral') {
            return 'FlowerHoroscopeCardA4'
        }

        return (templateType?.nameComponent
        ? templateType?.nameComponent?.endsWith('L')
            ? templateType?.nameComponent?.slice(0,-1)
            : templateType?.nameComponent
        : 'WarholCardA4')
    }, [templateType?.nameComponent, isMediiiaAstro, tab])

    const cardNumber = useMemo(() => getCardNumber(templateData?.number), [templateData?.number])

    const cardProps = useMemo(() => ({
        data: {
            templateType: {...templateType, link: window.location.hostname},
            templateData: {...templateData, link: window.location.hostname},
            number: cardNumber
        },
        templateType: templateTypeName,
        appName,
        contextName
    }), [templateType, templateData, cardNumber, templateTypeName, appName, contextName])

    if (!templateType || !templateData) {
        return null;
    }

    return (
            <AdaptiveCardWrapper cardProps={cardProps} images={images}>
                <CardComponent.MasterCard />
            </AdaptiveCardWrapper>
    );
}